module.exports = __webpack_public_path__ + "img/77.f3933574.jpg";